import { combineReducers } from 'redux';
import companies from './company.reducer';
import companyQualifications from './company.qualifications.reducer';

const companyAppReducer = combineReducers({
    companies, companyQualifications
});

export default companyAppReducer;


// WEBPACK FOOTER //
// src/main/content/company/store/reducers/index.js